import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';
import rem from 'polished/lib/helpers/rem';

import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';

import Grid from '@decisiv/ui-components/lib/components/Grid';

export const Container = styled(Grid.Container).attrs({
  padding: 0,
  margin: 0,
})<{
  width: string;
}>`
  z-index: 5;
  width: ${(props) => `${props.width}`};
`;

export const FullMoonRow = styled(Grid.Row).attrs({ margin: 0, padding: 1 })`
  background-color: ${toColorString(color.base.fullMoon)};
  border-top: 1px solid ${toColorString(color.opacity.charcoal15)};
`;

export const CustomColumn = styled(Grid.Column).attrs({ span: '6' })`
  display: flex;
  > :not(:last-child) {
    margin-right: ${rem(spacing.base * 0.5)};
  }
`;
